export * from './points-solicitation.page'